import React, { useMemo } from 'react'
import WorkoutTrendingForm from './_form'

export default function WorkoutTrendingAdd (props) {
  const trending = useMemo(() => ({ active: false }), [])

  return (
    <WorkoutTrendingForm trending={trending} {...props} />
  )
}